// Code: index.js 파일은 React 앱의 진입점입니다. 여기서는 React 앱을 렌더링하고, 브라우저에 표시합니다.
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import './index.css'; // 모든 css는 여기에서 import
import reportWebVitals from './reportWebVitals';

// React 18+ 버전에서는 ReactDOM.render 대신 ReactDOM.createRoot를 사용
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

reportWebVitals();
